module.exports = __webpack_public_path__ + "media/images/front/skill_chart_img-372d6e9ea8f35e42b1cd01fdbbf8f87a.png";